// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"18":"cashless-physio","52":"consultation","93":"reimbursement","368":"labs-v2"}[chunkId] || chunkId) + "." + {"18":"da4ec7f2","52":"8cab8a93","93":"c9888a36","189":"2e48116f","368":"134d1d1a","525":"29d2dabb","629":"8cab8a93","721":"29d2dabb","834":"e869ad06","892":"9ceb619e"}[chunkId] + ".chunk.css";
};